import { PhoneNumberUtil } from "google-libphonenumber";

import HWLog from "./HWLog";

// Checks if an object is undefined or empty. A string is empty if it has only whitespaces.
export const isEmpty = (object) => {
  return (
    object === undefined ||
    object === null ||
    (typeof object === "string" && object.trim() === "") ||
    (Array.isArray(object) && object.length === 0)
  );
};

export const isNullOrUndefined = (object) => {
  return object === undefined || object === null;
};

export const isAnyEmpty = (...objects) => {
  for (let object of objects) {
    if (isEmpty(object)) {
      return true;
    }
  }
  return false;
};

export const areAllEmpty = (...objects) => {
  for (let object of objects) {
    if (!isEmpty(object)) {
      return false;
    }
  }
  return true;
};

export const validateEmail = (emailId) => {
  if (!emailId) return false;
  const emailRegex =
    /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
  return emailRegex.test(emailId);
};

export const validateName = (name) => {
  if (!name) return false;
  return /^[a-zA-Z ]{2,30}$/.test(name) ? true : false;
};

export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  try {
    let phoneNumberString =
      phoneNumber.indexOf("+") === -1 ? "+" + phoneNumber : phoneNumber;
    let phoneNumberUtil = PhoneNumberUtil.getInstance();
    let number = phoneNumberUtil.parse(phoneNumberString);
    return phoneNumberUtil.isValidNumber(number);
  } catch (error) {
    return false;
  }
};

export const getUserLocation = () => {
  return Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject("No Location Access:");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (onSuccessResult) => {
        resolve(onSuccessResult);
        HWLog.info("SUCCESS LOCATION");
      },
      (onErrorResult) => {
        reject(onErrorResult);
        HWLog.info("ERROR LOCATION");
      }
    );
  });
};

export const dateByAdding = (numberOfDays) => {
  let date = new Date();
  date.setDate(date.getDate() + numberOfDays);
  return date;
};
export const returnDates = (date) => {
  if (isNullOrUndefined(date)) {
    return new Date();
  } else {
    return date;
  }
};
